
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["uqdzed",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M28.486 59.97c-6.636-.57-11.563-2.328-16.322-5.825C4.444 48.472 0 39.647 0 29.987 0 15.112 10.507 2.798 25.274.367c6.029-.992 12.704.05 18.288 2.854 13.577 6.818 19.782 22.54 14.643 37.103-3.528 9.998-12.79 17.618-23.391 19.245-2.086.32-5.065.509-6.328.4z","fill":"#1DA1F2","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M45.09 17.577c-.93.596-3.065 1.461-4.118 1.461v.002a6.602 6.602 0 00-11.206 6.034h-.001c-4.945-.13-10.354-2.608-13.61-6.85-2.001 3.464-.27 7.318 2.003 8.722-.778.059-2.21-.09-2.883-.747-.045 2.3 1.06 5.347 5.092 6.452-.776.418-2.15.298-2.749.21.21 1.94 2.929 4.479 5.902 4.479-1.06 1.225-5.046 3.448-9.52 2.74C17.038 41.93 20.58 43 24.327 43c10.65 0 18.922-8.632 18.477-19.28-.002-.012-.002-.024-.003-.037.001-.027.003-.054.003-.083 0-.033-.003-.064-.004-.096.97-.663 2.27-1.836 3.2-3.38-.539.297-2.156.891-3.66 1.039.965-.521 2.396-2.228 2.75-3.586","fill":"#FFF"}})])])
          )
        }
      }
    